/**
 * Internal: only UserStateAdapterBridge must import from this file.
 */

import type { UserSnapshot } from './user-state-adapter.shared';
import { userStateAdapter } from './user-state-adapter.shared';

export function setUserSnapshot(next: UserSnapshot): void {
  // We know that the adapter is implemented as a class and that the _setSnapshot method is private.
  // But we need to access it from the internal file to set the snapshot.
  // So we need to use @ts-ignore to bypass the type check.
  // It is only used here and in the adapter bridge.
  // @ts-ignore
  userStateAdapter._setSnapshot(next);
}
